import React from 'react';
import { graphql } from 'gatsby';
import PricingPage from 'components/pages/PricingPage';

const seo = {
  title: 'Q°emotion – Pricing and subscriptions',
  keywords: [],
  description:
    'Pay little and earn a lot. Improve your customer experience with Q°emotion at a price that matches your needs. Monthly or annual subscription. Free trial.',
};

export default props => <PricingPage seo={seo} {...props} />;

export const pageQuery = graphql`
  query {
    dataSyntheticPricing: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "syntheticPricingBlock" }
          lang: { eq: "en" }
          name: { ne: "Emotion Plus" }
        }
      }
    ) {
      nodes {
        frontmatter {
          index
          name
          benchmarkCount
          billedAnnualPrice
          categoriesMax
          commentsPerMonth
          commentsPerYear
          customerJourney
          dataCollection
          isCorporate
          liveSupport
          pricePerComment
          supportPriority
          reportingCount
          userCount
          annualPrice
          monthlyPrice
        }
      }
    }
    dataDetailedPricing: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "detailedPricingBlock" }
          lang: { eq: "en" }
          name: { ne: "Emotion Plus"}
        }
      }
    ) {
      nodes {
        frontmatter {
          index
          name
          pricePerComment
          monthlyPrice
          annualPrice
          billedAnnualPrice
          commentsPerYear
          commentsPerMonth
          categoriesMax
          customerJourney
          dataCollection
          automatedScheduler
          generalModules
          customerJourneyModule
          emotionalMapping
          alertModule
          insightModule
          benchmarkCount
          reportingCount
          userCount
          resultsDelivery
          fileImport
          fileSpecs
          yourSurveys
          tripadvisor
          googleMyBusiness
          amazonReviews
          otherWebReviews
          zendesk
          emails
          chatConversations
          socialNetworks
          blogs
          liveSupport
          helpCenter
          ticketsPriority
        }
      }
    }
    dataQuestionsFaqBlock: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "faqBlock" }
          lang: { eq: "en" }
          index: { gte: 1 }
        }
      }
      sort: { fields: [frontmatter___index] }
    ) {
      nodes {
        rawMarkdownBody
        html
        frontmatter {
          title
        }
      }
    }
    dataFooterFaqBlock: markdownRemark(
      frontmatter: {
        pageType: { eq: "pricing" }
        blockType: { eq: "faqBlock" }
        lang: { eq: "en" }
        index: { eq: 0 }
      }
    ) {
      html
    }
    dataBlockLinkBody: allMarkdownRemark(
      filter: {
        frontmatter: {
          pageType: { eq: "pricing" }
          blockType: { eq: "linkBlock" }
          lang: { eq: "en" }
        }
      }
      sort: { fields: [frontmatter___idBlock] }
    ) {
      nodes {
        rawMarkdownBody
        frontmatter {
          subTitle
          color
          link
          buttonText
        }
      }
    }
  }
`;
